import SettingDisplayController from './setting.display.controller';

export default {
    controller: SettingDisplayController,
    template: require('./setting.display.tpl.html')
};
